module.exports = __webpack_public_path__ + "static/media/sprinkler-plan.64fc9d9f.jpg";